import { render } from "./TextBanner.vue?vue&type=template&id=04b67a02&scoped=true"
import script from "./TextBanner.vue?vue&type=script&lang=js"
export * from "./TextBanner.vue?vue&type=script&lang=js"

import "./TextBanner.vue?vue&type=style&index=0&id=04b67a02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b67a02"]])

export default __exports__